<template>
    <!-- Kacheln -->
    <section class="tiles-property">
        <div class="pb-5">
            <div class="container">
                <div v-for="(article, i) in articles" class="row position-relative mb-3 py-4"
                    :class="{'bg-primary-light':(i % 2 === 0)}"
                >
                    <div class="col-12 col-sm-6 col-xl-5">
                        <img :src="article.image" class="w-100">
                    </div>
                    <div class="col-12 col-sm-6 col-xl-7">
                        <small>{{ article.pub_date_pretty }}</small>
                        <h2 class="text-primary display-6">{{ article.title }}</h2>
                        <p v-html="article.description"></p>
                        <a :href="`/blog/${article.slug}`" class="small stretched-link">weiterlesen</a>
                    </div>
                </div>
                <div class="row">
                    <div  v-if="loadMore" id="add-more-offerings-btn" class="col-12 text-center py-5 fade-in">
                        <button @click.prevent="getData"
                            :disabled="workers>0"
                            class="btn btn-primary"
                        >
                            Weitere Artikel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Kacheln -->
</template>

<script setup>

import {onMounted, ref} from "vue"

// props
const props = defineProps({
    paginationTake: Number
})

// variables
let paginationOffset = 0;

// reactive data
const workers = ref(0)
const articles = ref([])
const loadMore = ref(false)

// methods
const getData = () => {
    workers.value++

    // api request
    axios.get('/blog/list', {
        params: {
            skip: paginationOffset,
            take: props.paginationTake
        }
    })
        .then(response => {

            // append loaded articles
            articles.value.push(...response.data.articles)

            // increase pagination offset and enable/disable button
            if(paginationOffset + props.paginationTake < response.data.filteredCount){
                paginationOffset = paginationOffset + response.data.articles.length
                loadMore.value = true
            }
            else {
                loadMore.value = false
            }
        })
        .catch(error => {

        })
        .finally(() => {
            workers.value--
        })
}

// lifecycle hooks
onMounted(() => {
    getData()
})

</script>

<style scoped>

</style>
